import React from 'react'
import UserOptions from '@core/components/user-options/UserOptions'
import { AppBarV2Container } from './styles'

const AppBarV2 = () => (
    <AppBarV2Container>
        <UserOptions />
    </AppBarV2Container>
)

export default AppBarV2
